module.exports = __webpack_public_path__ + "img/the-sun.9aac13eb.svg";